import { useContext } from 'react'
import styled from 'styled-components'

import { MODALS_ID } from '../../../constants'

import { ModalContext } from '../../../provider/ModalProvider'

import { useNavigate } from '../../../hooks/useNavigate'

import { signOut } from '../../../api/auth'
import { withdrawalUser } from '../../../api/my'

import { Button } from '../../../components/button'
import { Modal } from '../../../components/modal'
import { Text, StyledText } from '../../../components/text'

import { Color } from '../../../theme/color'

export function WithdrawalConfirmModal() {
  const { closeModal } = useContext(ModalContext)

  const navigate = useNavigate()

  const close = () => closeModal(MODALS_ID.WITHDRAWAL_USER_CONFIRM)

  const withdrawal = async () => {
    await withdrawalUser()
    await signOut()
    navigate('/home')
    close()
  }

  return (
    <Modal id={MODALS_ID.WITHDRAWAL_USER_CONFIRM}>
      <Title size={18} weight={600} block={true}>
        정말 탈퇴하시겠어요?
      </Title>
      <List>
        <Item>
          <Text size={14} weight={500} lineHeight={20} color="text_secondary">
            탈퇴 후 발생하는 이벤트 혜택 및 알림은 받을 수 없어요.
          </Text>
        </Item>
        <Item>
          <Text size={14} weight={500} lineHeight={20} color="text_secondary">
            탈퇴 후 30일 간 재가입이 불가능해요.
          </Text>
        </Item>
      </List>
      <Modal.Footer>
        <Button onClick={withdrawal}>네</Button>
        <Button type="primary" onClick={close}>
          아니요
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

const Title = styled(StyledText)`
  margin-bottom: 16px;
  text-align: center;
`

const List = styled.ol`
  padding-left: 15px;
`

const Item = styled.li`
  font-size: 14px;
  color: ${Color.text_secondary};
  text-indent: -15px;
  list-style-position: inside;
`
